import script from "./ITeams.vue?vue&type=script&setup=true&lang=js"
export * from "./ITeams.vue?vue&type=script&setup=true&lang=js"

import "./ITeams.vue?vue&type=style&index=0&id=cbd8fe46&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbd8fe46"]])

export default __exports__